document.addEventListener('DOMContentLoaded', () => {

  const accordion = document.querySelector('.accordion');
  if (!accordion) return;

  const items = accordion.querySelectorAll('.accordion__item');
  const image = document.querySelector('#accordion-image-display');

  function closeAll() {
    items.forEach(item => {
      item.classList.remove('active');

      const answer = item.querySelector('.accordion__answer');
      if (answer) {
        answer.style.maxHeight = null;
        answer.hidden = true;
      }
    });
  }

  items.forEach((item, index) => {
    const button = item.querySelector('.accordion__question');
    const answer = item.querySelector('.accordion__answer');

    if (!button || !answer) return;

    button.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');

      closeAll();

      if (!isOpen) {
        item.classList.add('active');

        // ✅ open panel
        answer.hidden = false;
        answer.style.maxHeight = answer.scrollHeight + 'px';

        // ✅ swap image
        const newImage = item.getAttribute('data-image');

        if (newImage && image) {
          let url = newImage;

          if (url.startsWith('//')) {
            url = 'https:' + url;
          }

          // ✅ CRITICAL FIX for Shopify images
          image.removeAttribute('srcset');
          image.removeAttribute('loading');

          image.src = url;
        }
      }
    });

    // ✅ default open first
    if (index === 0) {
      item.classList.add('active');
      answer.hidden = false;
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  });

});